import React, { useState, useEffect } from 'react';
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';

const containerStyle = {
  width: '100%',
  height: '400px',
};

// Approximate — Al Hamra Business Tower, Al Sharq. Verify the pin before relying on it.
const center = {
  lat: 29.3797,
  lng: 47.9928,
};

const Map = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true); // Set isLoaded to true after the component mounts
  }, []);

  return (
    <div>
      {isLoaded ? (
        <LoadScript googleMapsApiKey="AIzaSyDWRyF4pnYMA2qYcRmihClbqGRRqlEGsy4">
          <GoogleMap
            mapContainerStyle={containerStyle}
            center={center}
            zoom={10}
          >
            <Marker position={center} />
          </GoogleMap>
        </LoadScript>
      ) : (
        <p>Loading Map...</p>
      )}
    </div>
  );
};

export default Map;